/* Model */
class AutoArriveLogModel extends App.Models.BaseModel {
    modelUrl = 'AutoArriveLog';
}

App.Models.AutoArriveLog = AutoArriveLogModel;

/* Collection */
class AutoArriveLogCollection extends App.Collections.BaseCollection {
    url = 'AutoArriveLog';
    model = App.Models.AutoArriveLog;
}

App.Collections.AutoArriveLogs = AutoArriveLogCollection;

/* Routers */
class AutoArriveLogRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'AutoArriveLog';
        const model = App.Models.AutoArriveLog;
        const collectionClass = App.Collections.AutoArriveLogs;

        super(entityName, model, collectionClass);
    }

    beforeList = function () {
        var controlUpdate = new Monet.Grid.ControlUpdate();
        var fieldsDefault = {
            'route.key': {
                value: ''
            },
            'route.date': {
                value: ''
            },
            'equipment.organization': {
                value: {
                    "id": '',
                    "description": ''
                }
            }
        };

        App.Forms.AutoArriveLog.filterBuilder.setDefaultFilters(fieldsDefault);
        App.Forms.AutoArriveLog.filterBuilder.adjustHeaderSize();

        controlUpdate.setEntityToNamespace(this.entityName);

        App.Forms[this.entityName].controlUpdater = controlUpdate;
    }
}

App.Routers.AutoArriveLog = AutoArriveLogRouter;